import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class CustomDateFormatService extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const data = localStorage.getItem(Constants.USER_CONFIGURATIONS);
    const plant = localStorage.getItem(Constants.CURRENT_PLANT);

    const userConfig = data ? JSON.parse(data) : null;
    const plantConfig = plant ? JSON.parse(plant) : null;

    // Default format if userConfig is not available
    const format = userConfig?.DateFormat || plantConfig?.dateFormat || 'DD/MM/YYYY';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    // Replace placeholders with actual values
    return format
      .replace('YYYY', year.toString())
      .replace('MM', month)
      .replace('DD', day);
  }
}
